import React from 'react';
import PropTypes from 'prop-types';
import { CheckCircle, AlertCircle } from 'lucide-react';

// SyncStatusBanner — renders the success / error flash banners shown above
// the connection card. Stateless; the parent owns the messages and clears
// them on successful actions.
export default function SyncStatusBanner({ successMsg, errorMsg }) {
  if (!successMsg && !errorMsg) return null;
  return (
    <>
      {successMsg && (
        <div
          className="mb-6 flex items-start gap-3 bg-background border rounded-[12px] p-4"
          style={{ borderColor: 'hsl(var(--succeedo-orange) / 0.3)' }}
        >
          <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: 'hsl(var(--succeedo-orange))' }} />
          <p className="text-[14px] text-foreground">{successMsg}</p>
        </div>
      )}
      {errorMsg && (
        <div className="mb-6 flex items-start gap-3 bg-background border border-red-200 rounded-[12px] p-4">
          <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5 text-red-500" />
          <p className="text-[14px] text-foreground">{errorMsg}</p>
        </div>
      )}
    </>
  );
}

SyncStatusBanner.propTypes = {
  successMsg: PropTypes.string,
  errorMsg: PropTypes.string,
};

SyncStatusBanner.defaultProps = {
  successMsg: null,
  errorMsg: null,
};
